var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconsColorfulSettings(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#6173FE"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M13.23 1.5c.302 0 .559.218.608.516l.378 2.304a7.927 7.927 0 0 1 1.647.684l1.87-1.335a.615.615 0 0 1 .793.065l1.74 1.74c.212.213.24.548.065.793l-1.335 1.87a7.93 7.93 0 0 1 .684 1.647l2.304.378a.615.615 0 0 1 .516.608v2.46a.615.615 0 0 1-.516.608l-2.304.378a7.925 7.925 0 0 1-.684 1.647l1.335 1.87a.615.615 0 0 1-.065.793l-1.74 1.74a.615.615 0 0 1-.793.065l-1.87-1.335a7.928 7.928 0 0 1-1.647.684l-.378 2.304a.615.615 0 0 1-.608.516h-2.46a.615.615 0 0 1-.608-.516l-.378-2.304a7.927 7.927 0 0 1-1.647-.684l-1.87 1.335a.615.615 0 0 1-.793-.065l-1.74-1.74a.615.615 0 0 1-.065-.793l1.335-1.87a7.927 7.927 0 0 1-.684-1.647l-2.304-.378a.615.615 0 0 1-.516-.608v-2.46c0-.302.218-.559.516-.608l2.304-.378a7.927 7.927 0 0 1 .684-1.647L3.67 6.267a.615.615 0 0 1 .065-.793l1.74-1.74a.615.615 0 0 1 .793-.065l1.87 1.335a7.927 7.927 0 0 1 1.647-.684l.378-2.304a.615.615 0 0 1 .608-.516h2.46zM12 7.5A4.505 4.505 0 0 0 7.5 12c0 2.481 2.019 4.5 4.5 4.5s4.5-2.019 4.5-4.5-2.019-4.5-4.5-4.5z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M12 16.5A4.505 4.505 0 0 1 7.5 12c0-2.481 2.019-4.5 4.5-4.5s4.5 2.019 4.5 4.5-2.019 4.5-4.5 4.5z",
    opacity: 0.163
  })))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconsColorfulSettings);
export default __webpack_public_path__ + "static/media/icons-colorful-settings.869d2d4d.svg";
export { ForwardRef as ReactComponent };